import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function TermsPage() {
  return (
    <div className="legal-page" data-testid="terms-page">
      <header className="legal-header">
        <Link to="/" className="legal-back" data-testid="terms-back-link">
          <ArrowLeft size={18} />
          Volver
        </Link>
        <h1>Términos y Condiciones — SUCO</h1>
        <p className="legal-updated">Última actualización: 3 de junio de 2026</p>
      </header>

      <main className="legal-content">
        <section>
          <h2>1. Identificación del prestador del servicio</h2>
          <p>
            El servicio <strong>SUCO</strong> es ofrecido por <strong>Juan José Mora Dávalos</strong>,
            persona física con actividades empresariales, con domicilio en Retorno Loma Valentina 11421-B,
            Col. Loma de Virreyes, Tijuana, Baja California, C.P. 22245, México.
            Contacto: <a href="mailto:info@sucomx.com">info@sucomx.com</a>.
          </p>
        </section>

        <section>
          <h2>2. Aceptación</h2>
          <p>
            Al registrarte y usar SUCO aceptas estos Términos y Condiciones y nuestra
            <Link to="/privacy"> Política de Privacidad</Link>.
            Si no estás de acuerdo, no debes utilizar el servicio.
          </p>
        </section>

        <section>
          <h2>3. Descripción del servicio</h2>
          <p>
            SUCO es una plataforma SaaS (Software como Servicio) que permite a negocios generar códigos QR
            personalizados, carteles imprimibles, formularios multilenguaje y un dashboard para administrar
            quejas y sugerencias de sus clientes finales. Incluye también la generación de códigos QR para WiFi
            y, en planes Empresariales, gestión de múltiples sucursales.
          </p>
        </section>

        <section>
          <h2>4. Planes y precios</h2>
          <ul>
            <li><strong>Prueba gratuita:</strong> 7 días sin cargo al registrarte.</li>
            <li><strong>Plan Mensual:</strong> $12.99 USD/mes.</li>
            <li><strong>Plan Anual:</strong> $110.00 USD/año.</li>
            <li><strong>Plan Empresarial Mensual:</strong> $29.99 USD/mes base + $5.99 USD por sucursal adicional.</li>
            <li><strong>Plan Empresarial Anual:</strong> $299.00 USD/año base + $59.00 USD por sucursal adicional.</li>
          </ul>
          <p>
            Los precios pueden actualizarse con notificación previa de 30 días vía correo electrónico al titular de la cuenta.
          </p>
        </section>

        <section>
          <h2>5. Pagos</h2>
          <p>
            Los pagos se procesan mediante <strong>Stripe</strong> y <strong>PayPal</strong>. SUCO no almacena información
            de tarjetas de crédito. Las suscripciones se renuevan automáticamente al finalizar cada periodo a menos que
            sean canceladas antes de la fecha de renovación desde el panel del usuario.
          </p>
        </section>

        <section>
          <h2>6. Cancelaciones y reembolsos</h2>
          <p>
            Puedes cancelar tu suscripción en cualquier momento desde el panel de control. La cancelación toma efecto
            al final del periodo de facturación en curso. <strong>No se otorgan reembolsos</strong> por periodos
            parciales ya consumidos, salvo casos excepcionales evaluados a discreción.
          </p>
        </section>

        <section>
          <h2>7. Obligaciones del usuario</h2>
          <ul>
            <li>Proporcionar información veraz y mantenerla actualizada.</li>
            <li>No utilizar SUCO para fines ilegales, fraudulentos o que vulneren derechos de terceros.</li>
            <li>No intentar acceder a sistemas, datos o cuentas ajenas.</li>
            <li>Mantener segura la contraseña de tu cuenta. Eres responsable de toda actividad realizada bajo tu cuenta.</li>
            <li>No publicar contenido difamatorio, ofensivo, discriminatorio o que infrinja propiedad intelectual.</li>
          </ul>
        </section>

        <section>
          <h2>8. Propiedad intelectual</h2>
          <p>
            La marca SUCO, el logotipo, el diseño del sitio, el código fuente y toda la propiedad intelectual asociada
            pertenecen exclusivamente a Juan José Mora Dávalos. El contenido que tú subas (logotipos, datos de tu negocio,
            quejas/sugerencias de tus clientes) permanece de tu propiedad; nos otorgas una licencia limitada para
            procesarlo y mostrarlo dentro del servicio.
          </p>
        </section>

        <section>
          <h2>9. Limitación de responsabilidad</h2>
          <p>
            SUCO se proporciona "tal cual" y "según disponibilidad". No garantizamos disponibilidad ininterrumpida ni
            ausencia total de errores. En ningún caso seremos responsables por daños indirectos, lucro cesante, pérdida
            de datos o cualquier daño derivado del uso o imposibilidad de uso del servicio, hasta el monto máximo de la
            cuota pagada por el usuario en los 12 meses anteriores al incidente.
          </p>
        </section>

        <section>
          <h2>10. Suspensión o terminación</h2>
          <p>
            SUCO se reserva el derecho de suspender o cancelar cuentas que infrinjan estos Términos, sin reembolso,
            previa notificación cuando sea posible.
          </p>
        </section>

        <section>
          <h2>11. Modificaciones</h2>
          <p>
            Podemos modificar estos Términos en cualquier momento. Notificaremos cambios sustantivos por correo
            al titular de la cuenta con al menos 15 días de anticipación. El uso continuado del servicio después
            de la fecha de entrada en vigor constituye aceptación de los nuevos términos.
          </p>
        </section>

        <section>
          <h2>12. Legislación aplicable y jurisdicción</h2>
          <p>
            Estos Términos se rigen por las leyes de los Estados Unidos Mexicanos. Para cualquier controversia,
            las partes se someten a la jurisdicción de los tribunales competentes de Tijuana, Baja California, México,
            renunciando a cualquier otro fuero que pudiera corresponderles.
          </p>
        </section>

        <section>
          <h2>13. Contacto</h2>
          <p>
            <strong>Juan José Mora Dávalos</strong><br />
            Retorno Loma Valentina 11421-B<br />
            Col. Loma de Virreyes, Tijuana, B.C. C.P. 22245, México<br />
            Correo: <a href="mailto:info@sucomx.com">info@sucomx.com</a>
          </p>
        </section>
      </main>

      <footer className="legal-footer">
        <p>© {new Date().getFullYear()} SUCO — Todos los derechos reservados.</p>
      </footer>
    </div>
  );
}
